import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [RouterModule, CommonModule, TranslateModule.forChild()],
  declarations: [SidebarComponent],
  exports: [SidebarComponent],
})
export class SidebarModule {}
